import { t } from '../../app/i18n';

export default {
  NPI: 'NPI',
  NEP: 'NEP',
  POD: 'POD',
  SCH: 'SCH',
  AUT: 'AUT',
  ZAM: 'ZAM',
  EXP: 'EXP',
  AKT: 'AKT',
  UP1: 'UP1',
  UP2: 'UP2',
  UP3: 'UP3',
  ODP: 'ODP',
  UZV: 'UZV',
  POOD: 'POOD',
  PUZV: 'PUZV',
  CNPZ: 'CNPZ',
  CNPP: 'CNPP',
  PRESCORING_FAILED: 'PRESCORING_FAILED',
  CNUD: 'CNUD',
  CANCELED: 'CANCELED',
  WITHDRAWN_BY_CLIENT: 'WITHDRAWN_BY_CLIENT',
  CANCELED_BY_ADMIN: 'CANCELED_BY_ADMIN',
  WAITING_CONTRACT_SIGNATURE: 'WAITING_CONTRACT_SIGNATURE',
  CONTRACT_SIGNATURE_PENDING: 'CONTRACT_SIGNATURE_PENDING',
};

export const translation = {
  NPI: t('V schvaľovaní'),
  NEP: t('Nepodaná'),
  POD: t('Pôžička čaká na schválenie'),
  SCH: t('Hľadáme pre Vás investora'),
  AUT: t('Hľadáme pre Vás investora (autoinvest)'),
  ZAM: t('Zamietnutá'),
  EXP: t('Nenaplnené financovanie'),
  AKT: t('Aktívna'),
  UP1: t('V omeškaní (1. upomienka)'),
  UP2: t('V omeškaní (2. upomienka)'),
  ODP: t('Odkup pohľadávky'),
  UZV: t('Uhradená'),
  POOD: t('Odpredaná'),
  PUZV: t('Predčasne uhradená'),
  CNPZ: t('Čakajúca na podpis zmlúv (CNPZ)'),
  CNPP: t('V procese podpisovania zmlúv (CNPP)'),
  PRESCORING_FAILED: t('Zamietnutá v predschvaľovaní'),
  CNUD: t('Čakajúca na nahratie výpisov z účtu a výplatnej pásky'),
  CANCELED: t('Zrušená žiadosť'),
  WITHDRAWN_BY_CLIENT: t('Odstúpené klientom'),
  CANCELED_BY_ADMIN: t('Zrušená žiadosť adminom'),
  WAITING_CONTRACT_SIGNATURE: t('Čaká na podpis nižšie uvedených zmlúv, podpisom súhlasíte s ich znením'),
  CONTRACT_SIGNATURE_PENDING: t('Čaká na potvrdenie podpisu finálnych zmlúv SMS kódom'),

};



// WEBPACK FOOTER //
// ./src/common/enums/loanStatus.js